export { QuizQuestionsMCAnswers } from "./QuizQuestionsMCAnswers";
